import styled from '@emotion/styled';
import React, {
  ChangeEvent,
  CSSProperties,
  InputHTMLAttributes,
  useEffect,
  useState,
} from 'react';
import { useSelector } from 'react-redux';

import plusPng from 'assets/images/plus.png';
import icPlusSVG from 'assets/images/ic-plus.svg';
import icCencleSVG from 'assets/images/close.png';

interface IFileUpload {
  label?: string;
  img?: any;
  setImg?: any;
  buttonStyle?: CSSProperties;
  iconStyle?: CSSProperties;
  icon?: string;
  limit: number;
  disabledPreview?: boolean;
}

const FileUpload = ({
  img,
  setImg,
  label,
  buttonStyle,
  icon,
  iconStyle,
  limit,
  disabledPreview,
}: IFileUpload & InputHTMLAttributes<HTMLDivElement>) => {
  const { isMobileWidth } = useSelector((s: any) => s.ui);
  const [thumbnails, setThumbnails] = useState<any>([]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;

    const fileList = e.target.files;

    let imageUrlList = [...thumbnails];

    for (let i = 0; i < fileList?.length; i++) {
      // @ts-ignore
      const newImages = URL.createObjectURL(fileList[i]);
      imageUrlList.push(newImages);
    }

    if (imageUrlList.length > limit) {
      imageUrlList = imageUrlList.slice(0, limit);
      setThumbnails(imageUrlList);
      window.alert(`이미지는 최대 ${limit}장까지 등록 가능합니다.`);
    }

    setThumbnails(imageUrlList);
    setImg([...img, e.target.files]);
  };

  const deleteFileImage = (index: number) => {
    URL.revokeObjectURL(thumbnails[index]);
    setThumbnails(thumbnails.filter((_: any, i: number) => i !== index));
    setImg(img.filter((_: any, i: number) => i !== index));
  };

  useEffect(() => {
    //언마운트시 메모리 누수 제거하기
    return () => URL.revokeObjectURL(thumbnails);
  }, []);

  return (
    <Container>
      <InputWrap>
        <UploadButton htmlFor='file' style={buttonStyle}>
          {icon ? <Icon style={iconStyle} src={icPlusSVG} /> : label}
        </UploadButton>
        <input
          type='file'
          multiple
          id='file'
          accept='image/* video/*'
          hidden
          onChange={(e) => {
            e.preventDefault();
            handleChange(e);
          }}
          style={{ display: 'none' }}
        />
      </InputWrap>

      {thumbnails.length !== 0 && !disabledPreview
        ? thumbnails.map((v: string, i: number) => {
            return (
              <ImageContainer key={i}>
                <XIcon
                  src={icCencleSVG}
                  onClick={(e) => {
                    e.preventDefault();
                    deleteFileImage(i);
                  }}
                />
                <ImageContent url={v} />
              </ImageContainer>
            );
          })
        : null}
    </Container>
  );
};

const Container = styled.label`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 14px;
  width: 100%;
`;

const InputWrap = styled.div`
  margin-top: 15px;
`;

const UploadButton = styled.label`
  width: 84px;
  height: 36px;
  font-size: 13px;
  padding: 10px 0;
  border-radius: 6px;
  border: solid 1px #000;
  background-color: #fff;
  cursor: pointer;
  text-align: center;
  letter-spacing: -0.26px;
`;

const Icon = styled.img`
  width: 36px;
  height: 36px;
`;

const ImageContainer = styled.span`
  position: relative;
  margin-top: 15px;
  margin-right: 15px;
`;

const Image = styled.img`
  width: 120px;
  height: 120px;

  border-radius: 12px;
  background-color: #eff7ff;
`;

const ImageContent = styled.div`
  width: 100px;
  height: 100px;

  border-radius: 12px;
  background-color: #eff7ff;

  background-image: ${(props: { url: string }) => ` url('${props.url}')`};
  background-position: center;
  background-size: cover;
`;

const XIcon = styled.img`
  position: absolute;
  cursor: pointer;
  top: 6px;
  right: 6px;
  width: 13px;
`;

export default FileUpload;
